import React, { useEffect } from 'react';

import Card from 'components/Card';
import useCompanyData from 'contexts/CompanyContext/hooks/useCompanyData';
import useUserData from 'contexts/UserContext/hooks/useUserData';
import { useTracking } from 'modules/segment/TrackingProvider';

import CompanyForm from './CompanyForm/CompanyForm';
import CompanyMembers from './CompanyMembers/CompanyMembers';
import CompanyTargetForm from './CompanyTargetForm/CompanyTargetForm';

const CompanySettings = () => {
  const { claimsAdmin } = useUserData();
  const { isActualOwnerOfCompany } = useCompanyData();
  const trackingService = useTracking();
  const isListOfMembersVisible = claimsAdmin || isActualOwnerOfCompany;

  useEffect(() => {
    trackingService.page('SettingsCompany');
  }, [trackingService]);

  return (
    <div className="flex flex-col gap-6">
      <Card
        title="Company"
        subtitle="This information will be displayed publicly so be careful what you
          share."
      >
        <div className="w-full">
          <CompanyForm />
        </div>
      </Card>
      {isListOfMembersVisible && (
        <Card
          title="Members"
          subtitle="Here you can invite other collaborators to your team."
        >
          <div className="w-full">
            <CompanyMembers />
          </div>
        </Card>
      )}

      <Card
        title="Targeting"
        subtitle="These options let you adjust which opportunities you are able to see."
      >
        <div className="w-full">
          <CompanyTargetForm />
        </div>
      </Card>
    </div>
  );
};

export default CompanySettings;
